import styled from 'styled-components'
import { Space } from 'antd'

export const SpaceWrapper = styled(Space)`
  width: 100%;
  disaplay: flex;
  align-items: flex-start;
  & .ant-space-item:first-child {
    width: 100%;
  }
  & .ant-form-item {
    border-bottom: none !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
`
